import React from 'react';
import Lozenge, { type ThemeAppearance } from '@atlaskit/lozenge';

export const LOZENGE_TYPES = {
	ON: 'ON',
	OFF: 'OFF',
	RESTRICTED: 'RESTRICTED',
};

type Props = {
	label: string;
	type: string;
};

const getAppearance = (type: string): ThemeAppearance => {
	switch (type) {
		case LOZENGE_TYPES.ON:
			return 'success';
		case LOZENGE_TYPES.OFF:
			return 'default';
		case LOZENGE_TYPES.RESTRICTED:
			return 'removed';
		default:
			return 'default';
	}
};

export const ChannelStatusLozenge = ({ label, type }: Props) => {
	const appearence = getAppearance(type);

	return <Lozenge appearance={appearence}>{label}</Lozenge>;
};
